import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_d01a0992-11a4-4272-94cc-141f8b794a67/artifacts/x7simg37_IMG_3934.png" 
              alt="Pacific Ghost" 
              className="footer-logo"
            />
            <p className="footer-tagline">Elite Baseball Development</p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Teams</h3>
            <ul className="footer-links">
              <li><Link to="/team/10u">10U</Link></li>
              <li><Link to="/team/11u">11U</Link></li>
              <li><Link to="/team/12u">12U</Link></li>
              <li><Link to="/team/13u">13U</Link></li>
              <li><Link to="/team/14u">14U</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-heading">High School</h3>
            <ul className="footer-links">
              <li><Link to="/highschool/2026">Class of 2026</Link></li>
              <li><Link to="/highschool/2027">Class of 2027</Link></li>
              <li><Link to="/highschool/2028">Class of 2028</Link></li>
              <li><Link to="/highschool/2029">Class of 2029</Link></li>
              <li><Link to="/highschool/2030">Class of 2030</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-heading">Contact</h3>
            <ul className="footer-contact">
              <li>
                <Mail size={18} />
                <a href="mailto:info@pacificghostbaseball.com">info@pacificghostbaseball.com</a>
              </li>
              <li>
                <Mail size={18} />
                <a href="mailto:jeremy@pacificghostbaseball.com">jeremy@pacificghostbaseball.com</a>
              </li>
              <li>
                <MapPin size={18} />
                <span>California</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Pacific Ghost Baseball. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;